import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudCheck: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-check, save"><path d="M4.96941 18.89C3.08259 18.1254 1.75 16.259 1.75 14.0779C1.75 11.4529 3.68024 9.28373 6.18382 8.94245C7.0149 6.50279 9.30502 4.75 12 4.75C14.695 4.75 16.9851 6.50279 17.8162 8.94245C20.3198 9.28373 22.25 11.4529 22.25 14.0779C22.25 16.259 20.9174 18.1254 19.0306 18.89" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 17L11.25 19.75L16.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCloudCheck;
